const calculateFirstYearSavings = (taxSavings, yearlyFees, opexAmount) => {
    return (
        taxSavings - yearlyFees - opexAmount
    )
}
export default calculateFirstYearSavings